/**
 * buildPullCommand returns the exact CLI command to pull a package at a given ref
 * (tag or version). It never invents flags (R10).
 *
 *   buildPullCommand("@acme/revenue-table", "latest") -> "bino registry add @acme/revenue-table@latest"
 *   buildPullCommand("@acme/revenue-table", "2.1.0")  -> "bino registry add @acme/revenue-table@2.1.0"
 */
export function buildPullCommand(pkg: string, ref: string): string {
  return `bino registry add ${pkg}@${ref}`;
}
